import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
	apiKey: 'AIzaSyD5d-2kopCVJQJQasr20g0AW-PMKOA_pDQ',
	authDomain: 'daeji-d7755.firebaseapp.com',
	databaseURL: 'https://daeji-d7755-default-rtdb.firebaseio.com',
	projectId: 'daeji-d7755',
	storageBucket: 'daeji-d7755.appspot.com',
	messagingSenderId: '1057274082824',
	appId: '1:1057274082824:web:cd7a8f51a905f45dce43bd',
	measurementId: 'G-LVM3HSSN2J',
};

const app = initializeApp(firebaseConfig);
export const authService = getAuth(app);
export const db = getFirestore(app);
export default app;
